import { Mail, Phone, MapPin, Navigation } from "lucide-react";
import { STUDIO } from "@/lib/studio";
import { buildMailto } from "@/lib/request";
import { Reveal, Eyebrow } from "./Reveal";

const Row = ({ icon: Icon, label, children }) => (
  <div className="flex gap-5 border-t border-gold-light/20 py-6">
    <Icon className="mt-1 h-5 w-5 shrink-0 text-gold-light" strokeWidth={1.4} />
    <div>
      <p className="text-[11px] uppercase tracking-[0.28em] text-gold-light">{label}</p>
      <div className="mt-2 text-lg text-cream">{children}</div>
    </div>
  </div>
);

export const Contact = () => (
  <section id="kontakt" data-testid="contact-section" className="bg-espresso py-24 text-cream lg:py-36">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-2 lg:gap-24">
      <Reveal>
        <Eyebrow index="04" light>Kontakt</Eyebrow>
        <h2 className="mt-6 font-serif text-5xl leading-[1.02] text-cream sm:text-6xl lg:text-7xl">
          Ich freue mich <span className="italic text-gold-light">auf dich.</span>
        </h2>
        <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-cream/80">Termine nach Vereinbarung – schreib mir eine E-Mail oder ruf mich einfach an.</p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <a href={buildMailto()} data-testid="contact-email-btn" className="btn-gold inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em]">
            <Mail className="h-4 w-4" /> E-Mail schreiben
          </a>
          <a href={STUDIO.phoneHref} data-testid="contact-call-btn" className="inline-flex items-center justify-center gap-3 rounded-full border border-gold-light/60 px-8 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] text-cream transition-colors duration-300 hover:bg-gold-light/10">
            <Phone className="h-4 w-4" /> Anrufen
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <Row icon={MapPin} label="Studio">
          <p className="font-serif text-2xl tracking-[0.18em]" data-testid="contact-name">MAISON PRINCESS</p>
          <address className="not-italic" data-testid="contact-address">{STUDIO.street}<br />{STUDIO.city}</address>
          <a href={STUDIO.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="contact-route-link" className="mt-3 inline-flex items-center gap-2 text-sm text-gold-light">
            <Navigation className="h-4 w-4" /> <span className="link-underline">Route planen</span>
          </a>
        </Row>
        <Row icon={Mail} label="E-Mail">
          <a href={`mailto:${STUDIO.email}`} data-testid="contact-email-link" className="link-underline">{STUDIO.email}</a>
        </Row>
        <Row icon={Phone} label="Telefon">
          <a href={STUDIO.phoneHref} data-testid="contact-phone-link" className="link-underline">{STUDIO.phone}</a>
        </Row>
      </Reveal>
    </div>
  </section>
);
